import { render, staticRenderFns } from "./TrainingExit.vue?vue&type=template&id=74037f35&scoped=true&"
import script from "./TrainingExit.vue?vue&type=script&lang=js&"
export * from "./TrainingExit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74037f35",
  null
  
)

export default component.exports